import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-loan-action',
  templateUrl: './dialog-loan-action.component.html',
  styleUrls: ['./dialog-loan-action.component.scss']
})
export class DialogLoanActionComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogLoanActionComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private privateService: PrivateService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  approveLoan() {
    this.isLoading = true;
    this.privateService.approveLoan(this.data.id).subscribe({
      next: res => {
        console.log(res);
        this.dialogRef.close();
        this.isLoading = false;
        window.location.reload();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

  declineLoan() {
    this.isLoading = true;
    this.privateService.declineLoan(this.data.id).subscribe({
      next: res => {
        console.log(res);
        this.dialogRef.close();
        this.isLoading = false;
        window.location.reload();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
